"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMap = void 0;
const MapContainer_1 = require("./MapContainer");
const react_1 = require("react");
function useMap(mapObject, callbacks) {
    const ref = (0, react_1.useRef)(null);
    const container = (0, react_1.useMemo)(() => (0, MapContainer_1.MapContainer)(ref, (e) => {
        //@ts-ignore
        mapObject.initialize(e, callbacks || {});
    }), []);
    return [container, mapObject];
}
exports.useMap = useMap;
